import { SC } from "../helper/ServerCall";

export const shippingService = {
    getAllShippingMethods
}

function getAllShippingMethods() {
    return SC.getCall('getAllShippingMethods');
}